import React from 'react'

export const preventSubmitHandler = event => {
  event.preventDefault()
  event.stopPropagation()
  return false
}

export const compareIds = (id1, id2) => `${id1}` === `${id2}`

export const safeTranslates = translates => translates instanceof Array ?
  Reflect.ownKeys(translates).reduce((acc, key) =>
    key === 'length' ? acc : ({ ...acc, [key]: translates[key] }),
  {})
  : translates

export const withZero = number => number > 9 ? `${number}` :  `0${number}`

export const getLetter = index => String.fromCharCode(('A'.charCodeAt(0) + index))

/* eslint-disable */
export const generateHash = (str, seed = 0) => {
  let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed
  for (let i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i)
    h1 = Math.imul(h1 ^ ch, 2654435761)
    h2 = Math.imul(h2 ^ ch, 1597334677)
  }
  h1 = Math.imul(h1 ^ h1>>>16, 2246822507) ^ Math.imul(h2 ^ h2>>>13, 3266489909)
  h2 = Math.imul(h2 ^ h2>>>16, 2246822507) ^ Math.imul(h1 ^ h1>>>13, 3266489909)
  return 4294967296 * (2097151 & h2) + (h1>>>0)
}
/* eslint-enable */


export const getWeights = (currentValue, values)  => {
  const statuses = Reflect.ownKeys(values)
  const result = []
  let i = 0
  let index = statuses.indexOf(currentValue)
  while(i < statuses.length) {
    if (index === statuses.length) {
      index = 0
    }
    result.push(statuses[index])
    i++
    index++
  }
  return result.reduce((acc, value, index) => ({ ...acc, [value]: statuses.length - index }), {})
}

export const convertIngredientDescription = ingredient => Reflect.ownKeys(ingredient.translates || {})
  .reduce((acc, value) => ({
    ...acc,
    ...(ingredient.translates[value] ? { [value]: ingredient.translates[value].description } : null),
  }), {})

export const beautifyList = list => {
  const copy = [...list]
  if (copy.length === 1) {
    return <b>{copy[0]}</b>
  }

  if (copy.length === 2) {
    return <span><b>{copy[0]}</b> and <b>{copy[1]}</b></span>
  }

  const last = copy.pop()
  return (
    <React.Fragment>
      {
        copy.map((item, index) =>
          index === copy.length - 1 ? <span key={index}><b>{item}</b> </span> : <span key={index}><b>{item}</b>, </span>,
        )
      }
      <span>and <b>{last}</b></span>
    </React.Fragment>
  )
}

export const queryParams = search => {
  const result = search
    .slice(1)
    .split('&').filter(Boolean)
    .map(p => p.split('='))
    .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {})
  if (!result.hasOwnProperty('page')) {
    result['page'] = 0
  }
  return result
}

export const objectToSearch = object => Object.keys(object).map(key => key + '=' + object[key]).join('&')

export default {
  preventSubmitHandler,
  compareIds,
  safeTranslates,
  withZero,
  generateHash,
  convertIngredientDescription,
  beautifyList,
  queryParams,
}
